import styled from 'styled-components';

export const Container = styled.div`
  width: 60%;
  height: 100%;
  margin: 0 auto;
  @media (max-width: 1024px) {
    width: 85%;
  }
`;